// extracted by mini-css-extract-plugin
module.exports = {"howItWorks":"HowItWorks_howItWorks__39Fsb","step":"HowItWorks_step__3QHBf","number":"HowItWorks_number__31GdN","mustRegister":"HowItWorks_mustRegister__2EJEO"};